import { render, staticRenderFns } from "./YagiofferDownloadItem.vue?vue&type=template&id=4bfafbc2&scoped=true"
import script from "./YagiofferDownloadItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagiofferDownloadItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./YagiofferDownloadItem.vue?vue&type=style&index=0&id=4bfafbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfafbc2",
  null
  
)

export default component.exports